import axios from 'axios';

const ROOT = 'api/v1/patient-bulk-update';

const PatientUpdateApi = {
  getStatusesForBulkUpdate(studyId) {
    return axios.get(`${ROOT}/study/${studyId}/statuses`, { hideLoader: true });
  },
  bulkStatusUpdate(request) {
    return axios.post(`${ROOT}/status`, request, { hideLoader: false });
  },
  bulkAddProgressNote(request) {
    return axios.post(`${ROOT}/progress-note`, request, { hideLoader: false });
  },
  bulkPatientInfoUpdate(request) {
    return axios.post(`${ROOT}/patient-info`, request, { hideLoader: false });
  },
  bulkStipendUpdate(request, studyId) {
    return axios.post(`${ROOT}/studies/${studyId}/patient-stipend`, request, { hideLoader: false });
  },
  downloadSampleFile() {
    return axios.get(`${ROOT}/download-sample`, {
      responseType: 'arraybuffer'
    });
  },
  downloadStipendSampleFile() {
    return axios.get(`${ROOT}/download-sample-stipend`, {
      responseType: 'arraybuffer'
    });
  }
};
export default PatientUpdateApi;
